module.exports = __webpack_public_path__ + "media/images/replay-eb45da90c27405d95bf1571c576e9101.png";